<template>
    <div class="transition1063-container">
      <div class="scroll-bg one"></div>
      <div class="scroll-bg two">
        <nuxt-img provider="static" format="webp"
          src="/img/1063-white.png"
          alt="1063"
          class="w-100 img-1063"
          sizes="xs:100vw sm:100vw lg:1920px xl:3000px"
        />
      </div>
    </div>
</template>

<script>

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default {
    data() {
        return {
            transition1063: null,
            transition1063Trigger: null
        }
    },
    components: {
        
    },
    mounted() {
      this.$nextTick(() => {
        ScrollTrigger.refresh();
        setTimeout(() => {
          this.transition1063 = gsap;

          var scrollTimeline = this.transition1063.timeline({ paused:true })
            .set('.transition1063-container', {
              height: 0
            })
            .to('.transition1063-container', {
              height: '600px',
            })
            .to('.scroll-bg', {
              height: '100%',
              ease: 'power1.out',
              stagger: 0.3,
              duration: 0.45
            })
            .to('.transition1063-container', {
              height: '0',
            })

          this.transition1063Trigger = ScrollTrigger.create({  
            trigger: '.transition1063-container',
            start: 'top bottom',
            end: '+=30%',
            animation: scrollTimeline
          })
        }, 500)
      })
    },
    beforeDestroy() {
      setTimeout(() => {
          this.transition1063Trigger.kill();
          // this.transition1063.kill();
        }, 500)
    }
}
</script>

<style scoped lang="scss">


  .transition1063-container{
    // display: flex;
    // height: 100vh;
    position: relative;
    // display: flex;
    background-color: #FF56B1;

    .scroll-bg {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
    }

    .one {
      background-color: #FF56B1;
      height: 0;
    }

    .two {
      // background-color: #ff40b3;
      height: 0;
    }

    @media screen and (max-width: 1199px) {
      display: none;
    }
  }



</style>